import React from 'react'
import Card from '../../controls/Card'
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus'
import StatusContainer from '../../controls/StatusContainer'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import Dp from './Dp'

export default function User({ user, title, isBorder, borderColor = "border-gray-400", isBack = false, subTitle, isRefresh = false, doRefresh }) {
    return (
        <Card borderColor={borderColor} isBack={isBack}
            title={title} isBorder={isBorder} subTitle={subTitle}
            isRefresh={isRefresh} doRefresh={doRefresh}
        >
            <div className='flex flex-col justify-center items-center'>
                <Dp user={user} height={"h-36"} width={"w-36"} />
                <h1 class="text-gray-900 font-bold text-lg leading-8 mt-1 flex item-center">Dr. {user.fullName}</h1>
                <div className='text-sm'>{user.specialisation?.name} ({user.specialisation?.shortName})</div>
                <div className='text-sm'>{user.degree}</div>
                <div className='text-sm'>{user.experiance} years of experience</div>
            </div>
        </Card>
    )
}
